import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#302681] to-[#831D1C] text-white py-12 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <MapPin className="w-6 h-6" />
              <h3 className="text-xl font-bold">ParkingSpot</h3>
            </div>
            <p className="text-sm opacity-90">
              A solução mais inteligente para encontrar vagas de estacionamento no Brasil.
            </p>
            <div className="mt-4">
              <p className="text-sm">parkingspotbrasil@gmail.com</p>
              <p className="text-sm">(11) 945252702</p>
              <p className="text-xs mt-2 opacity-75">24h por dia, 7 dias por semana</p>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Sobre</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/como-funciona" className="hover:underline opacity-90 hover:opacity-100">Como Funciona</Link></li>
              <li><Link to="/precos" className="hover:underline opacity-90 hover:opacity-100">Preços</Link></li>
              <li><Link to="/quem-somos" className="hover:underline opacity-90 hover:opacity-100">Quem Somos</Link></li>
              <li><Link to="/trabalhe-conosco" className="hover:underline opacity-90 hover:opacity-100">Trabalhe Conosco</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Suporte</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ajuda" className="hover:underline opacity-90 hover:opacity-100">Central de Ajuda</Link></li>
              <li><Link to="/faq" className="hover:underline opacity-90 hover:opacity-100">FAQ</Link></li>
              <li><Link to="/demo" className="hover:underline opacity-90 hover:opacity-100">Demo</Link></li>
              <li><Link to="/app" className="hover:underline opacity-90 hover:opacity-100">App</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/politica-privacidade" className="hover:underline opacity-90 hover:opacity-100">Política de Privacidade</Link></li>
              <li><Link to="/termos-uso" className="hover:underline opacity-90 hover:opacity-100">Termos de Uso</Link></li>
              <li><Link to="/direitos-autorais" className="hover:underline opacity-90 hover:opacity-100">Direitos Autorais</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-sm opacity-75">
          <p>&copy; 2025 ParkingSpot - by <a href="https://capibaragroup.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">Capibara Group</a> - Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
